export default "__VITE_ASSET__DiJemTsu__"